import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faArrowRotateBack, faHeartCircleCheck, faBatteryQuarter, faTruckField, faMoon } from '@fortawesome/free-solid-svg-icons';
import './CandleScope.css';
import candlescopeimage from '../../assets/pageimages/CandleScope.webp';

function CandleScopeHome() {
  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>CandleScope - Track Patterns </h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/candlescope-sleep-pattern" className="top-button-link"><FontAwesomeIcon icon={faMoon} className="candlescope-bottomlink-style" />Sleep Pattern</Link></div>
            <div className="bottom-buttons-box"><Link to="/candlescope-productivity" className="top-button-link"><FontAwesomeIcon icon={faArrowRotateBack} className="candlescope-bottomlink-style" />Productivity Pattern</Link></div>
            <div className="bottom-buttons-box"><Link to="/candlescope-health-and-fitness" className="top-button-link"><FontAwesomeIcon icon={faHeartCircleCheck} className="candlescope-bottomlink-style" />Fitness</Link></div>
            <div className="bottom-buttons-box"><Link to="/candlescope-energy-electricity" className="top-button-link"><FontAwesomeIcon icon={faBatteryQuarter} className="candlescope-bottomlink-style" />Energy Consumption</Link></div>
            <div className="bottom-buttons-box"><Link to="/candlescope-energy-fuel" className="top-button-link"><FontAwesomeIcon icon={faTruckField} className="candlescope-bottomlink-style" />Biofuel Consumption</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="candlescope-id" src={candlescopeimage} alt="CandleScopeImage" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default CandleScopeHome;
